import React, { memo as Memo, useEffect } from 'react'

import { withUIContext } from 'context'

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)
gsap.core.globals('ScrollTrigger', ScrollTrigger)

const AnimationWrap = Memo(({ state, startAnimeArr, startPoint, dependency, ...props }) => {
    useEffect(() => {
        let genArr = []

        if (!props.preloader && state?.length > 0 && state !== null) {
            state.forEach((el, i) => {
                if (el) {
                    ScrollTrigger.create({
                        trigger: el,
                        // markers: true,
                        start: startPoint || 'top bottom',
                        onEnter: () => {
                            genArr.push(true)

                            if (genArr.length <= state.length) {
                                startAnimeArr(genArr)
                            }
                        },
                    })
                }
            })
        }
    }, [state, props.preloader, dependency])

    useEffect(() => {
        return () => {
            ScrollTrigger.getAll().forEach((t) => t.kill())
        }
    }, [dependency])

    return <>{props.children}</>
})

export default withUIContext(AnimationWrap, ['preloader'])
